import { Trophy } from 'lucide-react';
import {
  WORLD_CUP_POLLA_LABEL,
  WORLD_CUP_POLLA_SHORT_LABEL,
  WORLD_CUP_POLLA_URL,
} from '../../constants/worldCupPolla.js';

function SoccerBallIcon({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden>
      <circle cx="12" cy="12" r="10" fill="white" stroke="#0f172a" strokeWidth="1.25" />
      <path
        d="M12 4.5 8.2 7.1 9.4 11.5 12 13.8l2.6-2.3 1.2-4.4L12 4.5Z"
        fill="#0f172a"
      />
      <path
        d="M12 13.8 9.4 11.5 6.8 12.8 7.5 16.2 12 18.2l4.5-2 0.7-3.4-2.6-1.3L12 13.8Z"
        fill="#0f172a"
      />
      <path d="M12 4.5 15.8 7.1 18.2 5.2M12 4.5 8.2 7.1 5.8 5.2" stroke="#0f172a" strokeWidth="1.1" />
      <path d="M18.2 5.2 19.8 9.1 17.2 12.8M5.8 5.2 4.2 9.1 6.8 12.8" stroke="#0f172a" strokeWidth="1.1" />
      <path d="M17.2 12.8 19.5 16.2 16.5 19.2M6.8 12.8 4.5 16.2 7.5 19.2" stroke="#0f172a" strokeWidth="1.1" />
      <path d="M16.5 19.2 12 18.2 7.5 19.2" stroke="#0f172a" strokeWidth="1.1" />
    </svg>
  );
}

export default function WorldCupPollaFloatingButton() {
  return (
    <a
      href={WORLD_CUP_POLLA_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`${WORLD_CUP_POLLA_LABEL}: abrir en una nueva pestaña`}
      title={WORLD_CUP_POLLA_LABEL}
      className="group relative flex max-w-[min(100vw-2rem,16rem)] items-center gap-2 overflow-hidden rounded-full border border-[#fbbf24] bg-gradient-to-r from-[#14532d] via-[#15803b] to-[#166534] px-2.5 py-1.5 text-white shadow-[0_6px_20px_rgba(251,191,36,0.28),0_4px_16px_rgba(21,128,61,0.4)] ring-1 ring-black/15 transition duration-300 hover:scale-[1.03] hover:border-[#fde047] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#fbbf24] motion-safe:animate-wcup-float sm:max-w-[18rem] sm:gap-2.5 sm:px-3 sm:py-2"
    >
        <span
          className="pointer-events-none absolute inset-0 bg-[linear-gradient(110deg,transparent_0%,rgba(255,255,255,0.14)_45%,transparent_70%)] opacity-0 transition duration-500 group-hover:opacity-100 motion-safe:animate-wcup-shine"
          aria-hidden
        />

        <span className="relative flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white/95 shadow-inner ring-1 ring-[#fbbf24]/70">
          <SoccerBallIcon className="h-5 w-5" />
        </span>

        <span className="relative min-w-0 text-left leading-tight">
          <span className="flex items-center gap-1">
            <Trophy className="h-3 w-3 shrink-0 text-[#fde047]" strokeWidth={2.25} aria-hidden />
            <span className="text-[9px] font-bold uppercase tracking-[0.16em] text-[#fde047] sm:text-[10px]">
              FIFA 2026
            </span>
          </span>
          <span className="block truncate text-xs font-bold sm:text-sm">{WORLD_CUP_POLLA_SHORT_LABEL}</span>
        </span>
    </a>
  );
}
